import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as generalActions from './general.actions';
import { catchError, map, of, switchMap } from 'rxjs';
import { GeneralApiService } from '@/_api/general.api.service';
import { SectionWWW } from '@/_store/general/general.types';

@Injectable()
export class GeneralDataEffects {
	constructor(
		private readonly actions$: Actions,
		private readonly generalApiService: GeneralApiService,
	) {}

	fetchMatProducts$ = createEffect(() =>
		this.actions$.pipe(
			ofType(generalActions.fetchSectionWWW),
			switchMap(() =>
				this.generalApiService.getSectionWWW().pipe(
					map((response) => response.results),
					map((sectionWWW: SectionWWW[]) => generalActions.fetchSectionWWWSuccess({ sectionWWW })),
					catchError(() => of(generalActions.fetchSectionWWWError())),
				),
			),
		),
	);
}
